import { useDefinedParam } from '@storebrand-digital/react-hooks';

import useProduct from './useProduct';

export default function useOnboardingParams() {
  const uid = useDefinedParam('uid');
  const product = useProduct();

  return {
    uid,
    product,
  } as const;
}
